var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0021 3.25C12.4164 3.25 12.7521 3.58579 12.7521 4V12C12.7521 12.4142 12.4164 12.75 12.0021 12.75C11.5879 12.75 11.2521 12.4142 11.2521 12V4C11.2521 3.58579 11.5879 3.25 12.0021 3.25ZM7.57517 5.51613C7.8424 5.83261 7.80248 6.3058 7.486 6.57303C5.24061 8.46904 4.41859 11.5657 5.428 14.3257C6.43742 17.0857 9.06332 18.9214 12.0021 18.9214C14.9409 18.9214 17.5668 17.0857 18.5763 14.3257C19.5857 11.5657 18.7636 8.46904 16.5183 6.57303C16.2018 6.3058 16.1619 5.83261 16.4291 5.51613C16.6963 5.19965 17.1695 5.15973 17.486 5.42697C20.2125 7.72926 21.2107 11.4895 19.985 14.8409C18.7593 18.1924 15.5707 20.4214 12.0021 20.4214C8.43358 20.4214 5.24498 18.1924 4.01926 14.8409C2.79354 11.4895 3.79172 7.72926 6.51826 5.42697C6.83474 5.15973 7.30793 5.19965 7.57517 5.51613Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.bc340e7b85ec73cd5413bf70c83a724a.svg";
export { ForwardRef as ReactComponent };